import HiringQuery from 'apps/hiring/util/query';
import { resolve } from 'library/helpers/path-resolver';

const archivedApplicantsQuery = (params={}) => (HiringQuery(`
  {
    organization {
      applications(limit: ${resolve(params, 'limit', 15)}, archived: true, offset: ${resolve(params, 'offset', 0)}, name: "${resolve(params, 'name', '')}") {
        pagination {
          total,
          limit,
          offset
        }
        results {
          id
          opening {
            id,
            name
          }
          survey: assessment {
            status: progress
            date: completion_date
          }
          user {
            name,
            id,
            email
          }
          resume_url,
          created_at
        }
      }
    }
  }
`));

const archivedApplicantsParseQuery = (data) => ({
  users: {
    pagination: resolve(data, 'organization/applications/pagination', {total:0}),
    results: resolve(data, 'organization/applications/results', []).map(r=>({
      date_applied: resolve(r, 'created_at', ''),
      name: resolve(r, 'user/name', ''),
      opening: resolve(r, 'opening', {}),
      resume: resolve(r, 'resume_url', ''),
      survey_status: resolve(r, 'survey/status', 'Pending'),
      view: `/hiring/openings/${resolve(r, 'opening/id')}/applicants/${resolve(r, 'id')}`
    }))
  }
});

export { archivedApplicantsQuery, archivedApplicantsParseQuery };
